import { Container, Graphics, Sprite, Texture, utils } from 'pixi.js';
import {
  BackgroundDef,
  BackgroundDefiniton,
  BackgroundService,
  GloveDefinition,
} from '../store/studio/background/background.service';
import { Coords } from '../../elements/resource/types/shape.type';
import { _screenX, _screenY } from '../../services/canvas/canvas.service';
import gsap from 'gsap';
import { GloveElement } from './shapes/background/glove';
import { GloveRectElement } from './shapes/background/glove-rr';
import { RectangleElement } from './shapes/primitive/rectangle-element';

export interface CanvasBackgroundConfig {
  thumbnail?: boolean;
  next?: boolean;
  prev?: boolean;
  isPortrait?: boolean;
}
export class CanvasBackground {
  sprite: Sprite;

  screenRectangle: RectangleElement;
  // get container() {
  //   if (this.next) {
  //     return this.bgService.nextContainer;
  //   }
  //   if (this.thumbnail) {
  //     return this.bgService.thumbnailContainer;
  //   }
  //   return this.bgService.container;
  // }
  container: Container;

  get thumbnail() {
    return this.config.thumbnail;
  }

  get next() {
    return this.config.next;
  }

  get prev() {
    return this.config.prev;
  }

  // get screenRectangle() {
  //   if (this.next) {
  //     return this.bgService.nextScreenRectangle;
  //   }

  //   if (this.prev) {
  //     return this.bgService.prevScreenRectangle;
  //   }

  //   if (this.thumbnail) {
  //     return this.bgService.thumbnailScreenRectangle;
  //   }

  //   return this.bgService.screenRectangle;
  // }

  strokeRectangle: RectangleElement;
  _gloves: Record<string, GloveElement | GloveRectElement> = {};
  gloves: Array<Graphics | Sprite> = [];
  bg: Graphics | Sprite;

  fillRectangle: RectangleElement;
  constructor(
    protected readonly bgService: BackgroundService,
    protected readonly config: CanvasBackgroundConfig = {},
    // public def: BackgroundDef,
  ) {
    this.container = new Container();
    const x = 2;
    const y = 2;
    const w = this.config.isPortrait ? 1080 : _screenX - 4;
    const h = this.config.isPortrait ? 1350 - 4 : _screenY;
    const r = 26;

    this.fillRectangle = new RectangleElement(undefined, this.container, {
      width: w,
      height: h,
      position: { x, y },
      r,
      fill: '#ffffff',
    });

    this.screenRectangle = new RectangleElement(undefined, this.container, {
      width: w,
      height: h,
      position: { x, y },
      r,
    });

    this.strokeRectangle = new RectangleElement(undefined, this.container, {
      width: w,
      height: h,
      position: { x, y },
      r,
      stroke: '#aaaaaa',
      'stroke-width': 2,
      noFill: true,
    });
  }

  setBackground(def: BackgroundDefiniton) {
    // -- // -- //
  }

  addToCanvas() {
    this.container.removeChildren();
  }

  initGlove(key: string, def: GloveDefinition) {
    const glow = new GloveElement(
      this.bgService,
      def,
      this.screenRectangle.element,
    );
    // const glow = ngew GloveElement(def);
    // const glow = new GloveRectElement(def); //
    // console.log('initGlove', key, def); //
    this._gloves[key] = glow;

    glow.sprite.mask = this.screenRectangle.element;

    // if (this.next) {
    //   glow.sprite.mask = this.bgService.nextScreenRectangle.element;
    // } else if (this.prev) {
    //   glow.sprite.mask = this.bgService.prevScreenRectangle.element;
    // } else {
    //   glow.sprite.mask = this.bgService.screenRectangle.element;
    // }
    this.container.addChild(glow.sprite);
  }

  setStateByTime(time: number) {
    // this.bgService.setBackgroundByTime(time);
  }

  private initBg(def: BackgroundDef): Graphics | Sprite {
    const { bg } = def;
    const bgRectangle = new Graphics();

    if (bg?.gradient) {
      // Attempt to render gradient via an offscreen canvas and map to a sprite texture
      bgRectangle.beginFill(0, 0.001);
      bgRectangle.drawRect(0, 0, _screenX, _screenY);
      bgRectangle.endFill();
      //const sprite = this.createGradientSprite(bg.color, bg.gradient);
      // if (sprite) return sprite;
      return bgRectangle;
    }

    // Fallback: solid color rectangle // -- // -- // -- //
    bgRectangle.beginFill(utils.string2hex(def.bg.color));
    bgRectangle.drawRect(0, 0, _screenX, _screenY);
    bgRectangle.endFill();
    return bgRectangle;
  }

  _animate(start: number, target: number): gsap.core.Timeline {
    // this.animate(target, duration).play() //;
    return gsap.timeline();
  }

  gsapAnimate(
    duration: number,
    params: any,
    ease?: string,
  ): gsap.core.Timeline {
    return gsap.timeline();
  }

  reset() {
    // -- // -- // -- //
  }

  animate(target: BackgroundDef, duration: number): gsap.core.Timeline {
    const tl = gsap.timeline({ paused: true });

    const currentGloves = this?.gloves;

    const nextDef = target;
    if (!nextDef) return tl;

    const nextGloves = nextDef.gloves || {};
    const nextKeys = Object.keys(nextGloves);
    const count = Math.min(currentGloves.length, nextKeys.length);

    for (let i = 0; i < count; i++) {
      const sprite = currentGloves[i];
      const target = nextGloves[nextKeys[i]];
      const [tx, ty] = target.center || [_screenX / 2, _screenY / 2];
      console.log('animation.glove.timeline', tx, ty);
      if (sprite) {
        tl.to(sprite, { x: tx, y: ty, duration, ease: 'power2.out' }, 0);
      }
    }
    return tl;
  }

  private createGlow(
    g: {
      color: string;
      alpha: number;
      center?: Coords;
      radius: Coords;
    },
    maskTarget: Graphics | Sprite,
  ): Graphics | Sprite {
    // -- // -- // -- // -- //
    const { color, alpha, center, radius } = g;
    const canvas = document.createElement('canvas');
    const size = radius[0] * 2;
    canvas.height = size * 2;
    canvas.width = size * 2;

    const ctx = canvas.getContext('2d');
    const gradient = ctx.createRadialGradient(size, size, 0, size, size, size);
    gradient.addColorStop(0, `rgba(${this.hexToRgb(color)},${1})`);
    gradient.addColorStop(1, `rgba(${this.hexToRgb(color)},0)`);

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // -- // -- // -- // -- // -- //
    const texture = Texture.from(canvas);
    const sprite = new Sprite(texture);
    sprite.anchor.set(0.5);

    const [x, y] = center || [_screenX / 2, _screenY / 2];
    sprite.position.set(x, y);

    sprite.mask = maskTarget;
    return sprite;
  }

  hexToRgb(hex: string) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Parse shorthand (e.g. #03F) to full form (e.g. #0033FF) //
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `${r}, ${g}, ${b}`;
  }

  private createGradientSprite(
    color: string,
    grad: {
      type: 'linear' | 'radial';
      start: Coords;
      end?: Coords;
      r?: number;
    },
  ): Sprite | null {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = _screenX;
      canvas.height = _screenY;
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;

      let gradient: CanvasGradient;
      if (grad.type === 'linear') {
        const [x0, y0] = grad.start;
        const [x1, y1] = grad.end || [x0 + _screenX, y0];
        gradient = ctx.createLinearGradient(x0, y0, x1, y1);
      } else {
        const [x0, y0] = grad.start;
        const r = grad.r ?? Math.max(_screenX, _screenY) / 2;
        gradient = ctx.createRadialGradient(x0, y0, 0, x0, y0, r);
      }

      // Use provided color with fade to transparent at edge
      const rgba = this.toRgba(color, 1);
      const rgba0 = this.toRgba(color, 0);
      gradient.addColorStop(0, rgba);
      gradient.addColorStop(1, rgba0);

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, _screenX, _screenY);

      const texture = Texture.from(canvas);
      this.sprite = new Sprite(texture);
      this.sprite.x = 0;
      this.sprite.y = 0;
      return this.sprite;
    } catch (e) {
      console.log('createGradientSprite failed', e.message);
      return null;
    }
  }

  private toRgba(color: string, alpha: number): string {
    // Basic #RRGGBB or #RGB parser fallback; if not hex, return color with alpha via rgba(0,0,0,a)
    const hex = color.replace('#', '');
    const parse = (v: string) => parseInt(v, 16);
    if (hex.length === 6) {
      const r = parse(hex.slice(0, 2));
      const g = parse(hex.slice(2, 4));
      const b = parse(hex.slice(4, 6));
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    // -- // -- //
    if (hex.length === 3) {
      const r = parse(hex[0] + hex[0]);
      const g = parse(hex[1] + hex[1]);
      const b = parse(hex[2] + hex[2]);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    // Fallback: let the browser parse, but apply alpha via canvas globalAlpha later if needed
    return color;
  }
}
